import { buildSelector } from '../lib/store';

export const [useUiControlsState, getUiControlsState] = buildSelector(
  (state, elementId: string) => state.uiControls[elementId]
);
